export const TopBarFocusIds = {
  hamburger: 'tob-bar-btn-hamburger',
  logo: 'tob-bar-btn-logo',
  location: 'tob-bar-btn-location',
  notifications: 'tob-bar-btn-notifications',
  settings: 'tob-bar-btn-settings',
  profile: 'tob-bar-btn-profile',
  taskTray: 'tob-bar-btn-task-tray',
  taskCenter: 'tob-bar-btn-task-center',
  quickFill: 'tob-bar-btn-quick-fill',
  schedulePulse: 'tob-bar-btn-schedule-pulse',
} as const;

export type TopBarFocusKey = keyof typeof TopBarFocusIds;

export function focusTopBarTarget(keyOrId: TopBarFocusKey | string, opts: { scroll?: boolean } = {}) {
  const id = (TopBarFocusIds as any)[keyOrId] || keyOrId;
  if (!id) return false;
  const el = document.getElementById(id) as HTMLElement | null;
  if (!el) return false;
  try {
    el.focus({ preventScroll: !opts.scroll });
    return true;
  } catch {
    return false;
  }
}

export function restoreFocusForIcon(icon: string) {
  if (!icon) return;
  focusTopBarTarget(icon);
}

export function safeFocus(id: string) {
  if (typeof document === 'undefined') return false;
  const el = document.getElementById(id) as HTMLElement | null;
  if (!el) return false;
  try {
    el.focus();
    return true;
  } catch {
    return false;
  }
}

export async function waitAndFocus(id: string, timeoutMs = 500): Promise<boolean> {
  const start = Date.now();
  while (Date.now() - start < timeoutMs) {
    if (safeFocus(id)) return true;
    await new Promise((r) => setTimeout(r, 16));
  }
  return false;
}
